<div class="alert" [style.--background-color]="backgroundColor" [style.--color]="color">
  @if (hasIcon && !icon) {
    @switch (variant) {
      @case ('success') {
        <mat-icon class="alert_icon">check_circle</mat-icon>
      }
      @case ('warn') {
        <mat-icon class="alert_icon">warning</mat-icon>
      }
      @case ('error') {
        <mat-icon class="alert_icon">cancel</mat-icon>
      }
      @case ('info') {
        <mat-icon class="alert_icon">info</mat-icon>
      }
    }
  } @else if (hasIcon && icon) {
    <mat-icon class="alert_icon">{{ icon }}</mat-icon>
  }

  <div class="alert_content">
    @if (title) {
      <h6 class="alert_title">{{ title }}</h6>
    }
    <p class="alert_message"><ng-content /></p>
  </div>
</div>
